export default [
  {
    path: '/classeImpostoOperacao/',
    name: 'classeImpostoOperacao',
    title: 'Classe imposto operação',
    component: () => import('../views/ClasseImpostoOperacaoFormView.vue'),
  },
];
